import { connect } from 'react-redux';
import EsnMappingComponent from './esn-mapping-component';
import { startRefresh, stopRefresh, search } from './grid/redux/action';

const mapStateToProps = (state: any) => ({
  application: state.application,
  queries: state.management.idMapping.form.queries
});
export default connect(mapStateToProps, { startRefresh, stopRefresh, search })(EsnMappingComponent);
